export const BLOOD_TYPES = [
  {
    value: "ND",
    text: "No definido",
  },
  {
    value: "O-",
    text: "O negativo",
  },
  {
    value: "O+",
    text: "O positivo",
  },
  {
    value: "A-",
    text: "A negativo",
  },
  {
    value: "A+",
    text: "A positivo",
  },
  {
    value: "B-",
    text: "B negativo",
  },
  {
    value: "B+",
    text: "B positivo",
  },
  {
    value: "AB-",
    text: "AB negativo",
  },
  {
    value: "AB+",
    text: "AB positivo",
  },
];
